import { render, staticRenderFns } from "./movementStockVehicleChart.vue?vue&type=template&id=36969fae&scoped=true"
import script from "./movementStockVehicleChart.vue?vue&type=script&lang=js"
export * from "./movementStockVehicleChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36969fae",
  null
  
)

export default component.exports